import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeLead } from 'src/types/shared/Challenge';

export const fetchChallengeLeadRequest = createAction('fetchChallengeLeadRequest');
export const fetchChallengeLeadSuccess = createAction<ChallengeLeadPayload>(
    'fetchChallengeLeadSuccess',
);
export const fetchChallengeLeadFailure = createAction('fetchChallengeLeadFailure');

export const fetchChallengeLead = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeLeadRequest());
    try {
        const { data } = await api.get<ChallengeLeadPayload>(
            `admin/challenges/${challengeID}/update-challengelead`,
        );
        dispatch(fetchChallengeLeadSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, fetchChallengeLeadFailure, e);
    }
};

export interface ChallengeLeadPayload {
    users: ChallengeLead[];
}
